module.exports = "https://trybtryb-legacy.web.app/img/thumbs-up.9ced6b9f.svg";